import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialNo',
    fieldName: '物料编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialClass',
    fieldName: '物料类别'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialUnit',
    fieldName: '物料单位',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialBrand',
    fieldName: '品牌',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialName',
    fieldName: '名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialModel',
    fieldName: '型号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialCode',
    fieldName: '代码'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialParameter',
    fieldName: '参数'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialDevice',
    fieldName: '使用设备'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessNo',
    fieldName: '业务编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessBrand',
    fieldName: '业务品牌'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessName',
    fieldName: '业务名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldName: '位置',
    fieldKey: 'locationFull'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldName: '采购状态',
    fieldKey: 'purchaseStatusValue'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldName: '出库状态',
    fieldKey: 'statusValue'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldName: '数量',
    fieldKey: 'num'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldName: '备注',
    fieldKey: 'des'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'approveUserName',
    fieldName: '出库确认人'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'approveTime',
    fieldName: '出库确认时间'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'backUserName',
    fieldName: '归还确认人'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'backTime',
    fieldName: '归还确认时间'
  }
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'price',
  //   fieldName: '含税总费用',
  //   isMoney: true,
  //   textAlign: 'right'
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'netPrice',
  //   fieldName: '未税总费用',
  //   isMoney: true,
  //   textAlign: 'right'
  // }
]
